module.exports = __webpack_public_path__ + "img/follow-two@3x.fa082a8e.png";